<form [formGroup]="formGroup">
  <mat-form-field style="width: 100%" class="input-headline">
    @if (talentHappyPathDataService.isGeneralApplication) {
      <mat-label>{{ 'talent-happy-path.quick-apply.submit-page.postal-code' | translate }}</mat-label>
    }
    <input
      type="text"
      matInput
      formControlName="homeLocation"
      placeholder="{{ locationPlaceholderKey | translate }}"
      id="locationAutocomplete"
      [matAutocomplete]="auto"
      #locationAutocompleteTrigger
      autocomplete="off">

    <!-- Autocomplete suggestions dropdown -->
    <mat-autocomplete #auto="matAutocomplete"
      [displayWith]="displaySuggestion"
      (optionSelected)="onPlaceSelected($event)">
      @for (suggestion of locationSuggestions; track suggestion) {
        <mat-option [value]="suggestion">
          <span class="suggestion-main">{{ getSuggestionMainText(suggestion) }}</span>
          <span class="suggestion-secondary">{{ getSuggestionSecondaryText(suggestion) }}</span>
        </mat-option>
      }
      @if (isLoadingLocation) {
        <mat-option disabled>
          <mat-spinner diameter="20"></mat-spinner>
          <span style="margin-left: 10px;">Searching...</span>
        </mat-option>
      }
    </mat-autocomplete>

    <!-- Error display -->
    @if (formGroup.get('homeLocation').hasError('required') && formGroup.get('homeLocation')?.touched) {
      <mat-error>
        {{ locationRequiredErrorKey | translate }}
      </mat-error>
    }
    @if (formGroup.get('homeLocation').hasError('invalidPlace') && formGroup.get('homeLocation')?.touched) {
      <mat-error>
        {{ invalidPlaceErrorKey | translate }}
      </mat-error>
    }
    @if (formGroup.get('homeLocation').hasError('placeDetailsError')) {
      <mat-error>
        {{ 'talent-happy-path.quick-apply.error.failed-to-get-location' | translate}}
      </mat-error>
    }
  </mat-form-field>
</form>
